import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Popover from './Popover';
import Explanation_text from './Explanation_text';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/Info'

export default function SimplePopover(props) {

  return (
    <Popover trigger={<span style={{marginLeft:'10px', marginTop:'5px'}}><InfoIcon style={{fontSize:'15px', cursor:'pointer'}} size='small' color='primary'/></span>} content={
      <div style={{width:'600px'}}>
        <div style={{marginTop:'5px', width:'calc(100% - 20px)', marginLeft:'10px'}}><Explanation_text text={props.name+'_info_title'}/></div>
        <hr style={{width:'100%'}}/>
        <div style={{marginBottom:'5px', width:'calc(100% - 20px)', marginLeft:'10px'}}><Explanation_text variant='caption' text={props.name+'_info_text'}/></div>
      </div>
    }/>
  );
}
